export default [{
  path: 'vehicleLocation',
  name: 'vehicleLocation',
  component: function component() {
    return import('@/views/vehicleLocationManage/index');
  }
}, {
  path: 'vehicleLocationDetail',
  name: 'vehicleLocationDetail',
  component: function component() {
    return import('@/views/vehicleLocationManage/detail.vue');
  }
}, {
  path: 'vehicleTraceReplay',
  name: 'vehicleTraceReplay',
  component: function component() {
    return import('@/views/vehicleTraceReplayManage/traceReplay.vue');
  }
}, {
  path: 'vehicleTraceDetail',
  name: 'vehicleTraceDetail',
  component: function component() {
    return import('@/views/vehicleTraceReplayManage/trackDetail.vue');
  }
}, {
  path: 'vehicleTraceDetailMap',
  name: 'vehicleTraceDetailMap',
  component: function component() {
    return import('@/views/vehicleTraceReplayManage/base/vehicleOperationDetailMap.vue');
  }
}, {
  path: 'carTraceMap',
  name: 'carTraceMap',
  component: function component() {
    return import('@/views/vehicleTraceReplayManage/carTraceMap.vue');
  }
}, {
  path: 'vehicleOperation',
  name: 'vehicleOperation',
  component: function component() {
    return import('@/views/vehicleOperationManage/index');
  }
}, {
  path: 'vehicleOperationDetail',
  name: 'vehicleOperationDetail',
  component: function component() {
    return import('@/views/vehicleOperationManage/detail');
  }
}, {
  path: 'vehicleOperationDetailMap',
  name: 'vehicleOperationDetailMap',
  component: function component() {
    return import('@/views/equipmentOperation/base/vehicleOperationDetailMap');
  }
}, {
  path: 'vehicleOperationDetailMapV2',
  name: 'vehicleOperationDetailMapV2',
  component: function component() {
    return import('@/views/equipmentOperation/base/vehicleOperationDetailMap');
  }
}, {
  path: 'vehicleTrajectoryMap',
  name: 'vehicleTrajectoryMap',
  component: function component() {
    return import('@/views/vehicleOperationManage/base/trajectoryMap');
  }
},
//出勤
{
  path: 'carAttendance',
  name: 'carAttendance',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/index/indexCar');
  }
}, {
  path: 'vehicleAttendance',
  name: 'vehicleAttendance',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/index/indexVehicle');
  }
},
//燃油
{
  path: 'fuelVehicle',
  name: 'fuelVehicle',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuel/fuelVehicle');
  }
}, {
  path: 'vehicleFuelVehicle',
  name: 'vehicleFuelVehicle',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuel/vehicleFuelVehicle');
  }
}, {
  path: 'avgFuelConsumptionList',
  name: 'avgFuelConsumptionList',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuel/fuelAvgVehicle');
  }
}, {
  path: 'vehicleAvgFuelConsumptionList',
  name: 'vehicleAvgFuelConsumptionList',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuel/vehicleFuelAvgVehicle');
  }
}, {
  path: 'fuelCar',
  name: 'fuelCar',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuel/fuelCar');
  }
},
//用油分析表
{
  //设备
  path: 'oilAnalysisVehicle',
  name: 'oilAnalysisVehicle',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/oilAnalysis/oilAnalysisVehicle');
  }
}, {
  //车辆
  path: 'oilAnalysisCar',
  name: 'oilAnalysisCar',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/oilAnalysis/oilAnalysisCar');
  }
}, {
  //单施工设备出勤统计表
  path: 'indexNoeVehicle',
  name: 'indexNoeVehicle',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/noe/indexNoeVehicle');
  }
}, {
  //单车辆出勤统计表
  path: 'indexNoeCar',
  name: 'indexNoeCar',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/noe/indexNoeCar');
  }
},
// 施工设备加油量比对管理统计表
{
  //施工设备
  path: 'fuleCompareVehicle',
  name: 'fuleCompareVehicle',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuleCompare/indexVehicle');
  }
}, {
  // 施工设备用油分析表(单)
  path: 'fuleNoeVehicle',
  name: 'fuleNoeVehicle',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuelNoe/indexVehicle');
  }
}, {
  // 车辆用油分析表(单)
  path: 'fuleNoeCar',
  name: 'fuleNoeCar',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuelNoe/indexCar');
  }
}, {
  //  物联设备信号连接状态
  path: 'stateLinkVehicle',
  name: 'stateLinkVehicle',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/stateLink/indexVehicle');
  }
}, {
  //  物联设备信号连接状态详情
  path: 'stateLinkDetails',
  name: 'stateLinkDetails',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/stateLink/details');
  }
}, {
  path: 'fuelVehicleWorkHour',
  name: 'fuelVehicleWorkHour',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuel/fuelVehicleWorkHour/index');
  }
}, {
  path: 'fuelVehicleMileage',
  name: 'fuelVehicleMileage',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/fuel/fuelVehicleMileage/index');
  }
}, {
  path: 'vehicleAttendanceList',
  name: 'vehicleAttendanceList',
  component: function component() {
    return import('@/views/vehicleAttendanceList/index');
  }
}, {
  path: 'carAttendanceList',
  name: 'carAttendanceList',
  component: function component() {
    return import('@/views/carAttendanceList/index');
  }
}, {
  path: 'freightageAttendanceList',
  name: 'freightageAttendanceList',
  component: function component() {
    return import('@/views/freightageAttendanceList/index');
  }
}, {
  path: 'fuelVehicleWork',
  name: 'fuelVehicleWork',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/work');
  }
}, {
  path: 'fuelVehicleCheckNoe',
  name: 'fuelVehicleCheckNoe',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/check/checkNoe');
  }
}, {
  path: 'standaloneAccountingList',
  name: 'standaloneAccountingList',
  component: function component() {
    return import('@/views/standaloneAccountingManage/list');
  }
}, {
  path: 'standaloneAccountingEdit',
  name: 'standaloneAccountingEdit',
  component: function component() {
    return import('@/views/standaloneAccountingManage/edit');
  }
}, {
  path: 'standaloneAccountingDetail',
  name: 'standaloneAccountingDetail',
  component: function component() {
    return import('@/views/standaloneAccountingManage/detail');
  }
}, {
  path: 'standaloneAccountingSuccess',
  name: 'standaloneAccountingSuccess',
  component: function component() {
    return import('@/views/standaloneAccountingManage/success');
  }
}, {
  path: 'vehicleInfoStatistics',
  name: 'vehicleInfoStatistics',
  component: function component() {
    return import('@/views/vehicleAttendanceManange/infoStatistics/index');
  }
}];
export var activeMenu = {
  '/main/vehicleTraceDetail': '/main/vehicleTraceReplay',
  '/main/carTraceMap': '/main/vehicleTraceReplay'
};